/**
 * 通用业务配置
 */

/** 登录/重新登录时使用的 basic 配置 */
export const LOGIN_BASIC_CONFIG = {
  ab_test: "0.5",
  sdk_version_code: 3,
  sdk_version_name: "2.2.0",
  sn_language: "en_US",
  SDK_ID: 1000,
} as const;
